export default __webpack_public_path__ + "static/media/gn.4747aac7.svg";